import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forEach } from 'lodash';
import { Observable, empty, throwError } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { IProductAttribute, IProductAttributesGetByattributeIdBody, ProductAttribute, BaseResponse } from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class ProductAttributeService {
  //#region constructor & Members
  constructor(private httpClient: HttpClient) { }

  //#endregion
  //#region ProductAttributeService Api endPoints
  public getAll(): Observable<Array<ProductAttribute>> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_ATTRIBUTE.GET_ALL}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((productAttributes) => { this.PRODUCT_ATTRIBUTES = productAttributes })
      );
  }
  public get(attributeId: number): Observable<IProductAttribute> {
    const endPoint = `${ConfigService.APIs.endPoints.PRODUCT_ATTRIBUTE.GET}/${attributeId}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
        tap((productAttribute) => { console.log(productAttribute); })
      );
  }
  //Need to confirm whether we can use single method for Save/Update 
  public addProductAttribute(data: ProductAttribute): Observable<ProductAttribute> {
    if (data.attributeValues) {
      data.attributeValues.forEach((item, index) => {
        item.displaySequence = (+index);
        item.attributeId = +0;
        item.attributeValueId = +0;
        item.isActive = true;

      });
    }
    const apiEndpoint = `${ConfigService.APIs.endPoints.PRODUCT_ATTRIBUTE.ADD_ATTRIBUTE}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; } ),
        tap((productAttribute) => this.addOrUpdateProductAttribute(productAttribute))
      );
  }

  public updateProductAttribute(data: ProductAttribute): Observable<Array<ProductAttribute>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.PRODUCT_ATTRIBUTE.UPDATE_ATTRIBUTE}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
    .pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => response.data)
    );
    // .pipe(tap((productAttributes) => this.addOrUpdateProductAttributes = productAttributes));
  }
  public attributesById(body: IProductAttributesGetByattributeIdBody): Observable<Array<ProductAttribute>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.PRODUCT_ATTRIBUTE.ATTRIBUTE_BY_ID}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }

  public deleteProductAttribute(data: ProductAttribute): Observable<any> {

    const apiEndpoint = `${ConfigService.APIs.endPoints.PRODUCT_ATTRIBUTE.DELETE_ATTRIBUTE}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
        tap((productAttribute) => this.addOrUpdateProductAttribute(productAttribute))
      );
  }
  //#endregion

  //#region ProductAttributeService CAche

  private PRODUCT_ATTRIBUTES: Array<ProductAttribute> = [];


  public get productAttributes(): Array<ProductAttribute> {
    if (!this.PRODUCT_ATTRIBUTES) {
      this.PRODUCT_ATTRIBUTES = [];
    }
    return this.PRODUCT_ATTRIBUTES;
  }

  public set productAttributes(productAttributes: Array<ProductAttribute>) {
    this.PRODUCT_ATTRIBUTES = productAttributes;
  }

  private addOrUpdateProductAttribute(productAttribute: ProductAttribute) {
    if (productAttribute) {

      const indextemp = this.productAttributes.findIndex(r => r.attributeId === productAttribute.attributeId);
      const temp = this.productAttributes.find(r => r.attributeId === productAttribute.attributeId);
      if (temp) {
        this.PRODUCT_ATTRIBUTES.splice(indextemp, 1, productAttribute);
      } else {
        this.PRODUCT_ATTRIBUTES.push(productAttribute);
      }


    }

  }



  //#endregion
  //#region ProductAttributeService BusinessFunction
  //#endregion

}
